module.exports = __webpack_public_path__ + "static/img/7.58b61dd7.jpg";